import { render, staticRenderFns } from "./VisualizarPagamentoEletronico.vue?vue&type=template&id=efab36c0&scoped=true"
import script from "./VisualizarPagamentoEletronico.vue?vue&type=script&setup=true&lang=js"
export * from "./VisualizarPagamentoEletronico.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VisualizarPagamentoEletronico.vue?vue&type=style&index=0&id=efab36c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efab36c0",
  null
  
)

export default component.exports